<template>
  <div>
    <ContentHeader title="" />
    <section class="content">
      <div class="container-fluid">
        <div>
          <div class="d-flex align-items-center py-3">
            <h3 class="d-inline mr-4 ml-3">Active Bank Account</h3>
            <router-link v-if="filteredBanks.length == 0"
              :to="{ name: 'AddBank' }"
              class="btn btn-success rounded-pill"
              ><i class="fas fa-plus"></i>
              <span class="px-2">Add bank account</span></router-link
            >
          </div>
          <div v-if="filteredBanks.length > 0" class="container-fluid mt-2">
            <div class="alert alert-danger w-100" role="alert">
              If you want to edit and delete a bank account, please contact the admin immediately
            </div>
          </div>
          <div v-if="loading" class="d-flex bank-account-container px-1 px-md-3">
            <bank-card skeleton/>
          </div>
          <div v-else-if="filteredBanks.length > 0" v-dragscroll class="d-flex bank-account-container px-1 px-md-3">
            <bank-card
              v-for="bank in filteredBanks"
              :key="bank.id"
              :bank="bank"
              :accountNumber="formatBankNumber(bank.account_number)"
              @deleteItem="deleteItem"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import BankCard from "@/components/molecules/BankCard.vue";
import apiClient from "../../services/ApiServices";
import axios from "axios";
import { dragscroll } from "vue-dragscroll";

export default {
  directives: {
    dragscroll,
  },
  components: {
    ContentHeader,
    BankCard,
  },

  data() {
    return {
      loading: true,
      banks: [],
    };
  },
  computed: {
    filteredBanks() {
      return this.banks.filter((item) => !item.deleted_at);
    },
  },

  created() {
    document.title = "Bank - Manager Cabang";
  },
  async mounted() {
    try {
      let bankAccount = await apiClient.get(
        `bank/?corporate_partner_id=${this.$user_id}`
      );

      this.banks = bankAccount.data.data;
    } catch (error) {
      this.$swal(
        "Oooopss....",
        error.data.data.message,
        "error"
      );
      console.log(error.data.message);
    } finally {
      this.loading = false
    }
  },
  methods: {
    formatBankNumber(value) {
      let number = value.toString().match(/.{1,4}/g)
      return number.join(' ')
    },
    deleteItem(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          axios.delete(`/bank/${id}/`).then(() => {
            this.banks = this.banks.filter((item) => item.id != id);
          });

          this.$swal("Deleted!", "Your file has been deleted.", "success");
        }
      });
    },
    logout() {
      this.$store.dispatch("logout");
    },
  },
};
</script>

<style scoped>
.bank-account-container {
  overflow-x: scroll;
}
.bank-accounts {
  width: 400px;
  margin-right: 1rem;
  flex-shrink: 0;
  position: relative;
}
.bank-name {
  position: absolute;
  top: 0;
  right: 0;
}
.bank-button-container {
  flex: 1 1 0px;
}
.bank-button-container > .btn {
  flex-grow: 1;
}
@media (min-width: 319px) {
}

@media (min-width: 374px) {
  .bank-account-container {
    overflow-x: scroll;
  }
}

@media (min-width: 424px) {
  .bank-account-container {
    overflow-x: hidden;
  }
}

@media (min-width: 767px) {
}

@media (min-width: 1023px) {
}

@media (min-width: 1439px) {
}

@media (min-width: 2000px) {
}
</style>